import api from '../../services/api';

const baseUrl = 'crm/contact'

const findAll = async () =>
    api.get({ service: `${baseUrl}/` });

const findById = async (id) =>
    api.get({ service: `${baseUrl}/${id}` });

const create = async (values) =>
    api.post({ service: baseUrl, data: values });

const findByNamePartial = async (name) =>
    api.get({ service: `${baseUrl}/name/${name}` });

export default {
    findAll,
    findById,
    create,
    findByNamePartial
}